import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useQueryClient } from 'react-query';

import closeIcon from 'images/directory/x_icon.svg';

import { deleteEntityJoin } from '../../../../../utils/backend-api/entity_joins';
import { IDENTITIES_KEY } from '../../../../../utils/backend-api/identities';
import { capitalize } from '../../../../../utils/formatting';
import { Pill } from '../../../../BaseUI';

const TopicTag = ({ entity, identityId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const queryClient = useQueryClient();

  const handleRemoveTopic = async () => {
    setIsSubmitting(true);
    const sanitizedParams = {
      entity_id: entity.id,
      relationship_source: 'topic',
      parent_type: 'Identity',
      parent_id: identityId,
    };
    try {
      const result = await deleteEntityJoin(sanitizedParams);
      if (result) {
        queryClient.invalidateQueries([IDENTITIES_KEY, identityId]);
      } else {
        // Let catch handle response to user
        throw 'deleteEntityJoin result unsuccessful';
      }
    } catch (e) {
      console.error('Failed to deleteEntityJoin', e, sanitizedParams);
      toast.error('Sorry, unable to remove topic. Please try again.');
    }
    setIsSubmitting(false);
  };

  return (
    <Pill
      onClick={handleRemoveTopic}
      className="--neutral"
      /* capitalize first letter of each word (can't use lodash's startCase because it removes special characters) */
      text={capitalize(entity.name)}
      icon={closeIcon}
      disabled={isSubmitting}
    />
  );
};

export default TopicTag;
